export const DefaultOwner = 'DOwner$#$'
export default {
  DefaultOwner
}
